import script from "./ViewOfferProjectModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewOfferProjectModel.vue?vue&type=script&lang=ts&setup=true"

import "./ViewOfferProjectModel.vue?vue&type=style&index=0&id=0cf74d18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cf74d18"]])

export default __exports__